import { MessageSchema } from "@redotech/redo-agents-common/llm-messages";
import { llmThreadLiteSchema } from "@redotech/redo-agents-common/llm-thread-lite";
import * as zExt from "@redotech/rpc/ext";
import * as z from "zod";

export const getLlmThread = {
  name: "getLlmThread" as const,
  input: z.object({ llmThreadId: zExt.objectId() }),
  output: z
    .object({ thread: llmThreadLiteSchema, messages: z.array(MessageSchema) })
    .nullable(),
};
